window.addEventListener("load", function () {
   
    // Mobile: nút prev/next cuộn dải đổi điểm (.list-doidiem)
    var doidiemList = document.querySelector(".list-doidiem");
    var prevBtn = document.querySelector(".btn-doidiem-prev");
    var nextBtn = document.querySelector(".btn-doidiem-next");
    if (doidiemList && prevBtn && nextBtn) {
        // 1 lần click trượt đúng 2 card = 2 x (card 290 + khe 40)
        var STEP = 2 * (290 + 40);

        // Làm xám nút khi cuộn tới đầu/cuối
        function updateDoidiemNav() {
            var maxScroll = doidiemList.scrollWidth - doidiemList.clientWidth;
            prevBtn.classList.toggle("disabled", doidiemList.scrollLeft <= 2);
            nextBtn.classList.toggle("disabled", doidiemList.scrollLeft >= maxScroll - 2);
        }

        nextBtn.addEventListener("click", function (e) {
            e.preventDefault();
            doidiemList.scrollBy({ left: STEP, behavior: "smooth" });
        });
        prevBtn.addEventListener("click", function (e) {
            e.preventDefault();
            doidiemList.scrollBy({ left: -STEP, behavior: "smooth" });
        });

        // Cập nhật khi cuộn (gồm cả lúc smooth-scroll do click) + lúc khởi tạo
        doidiemList.addEventListener("scroll", updateDoidiemNav);
        window.addEventListener("resize", updateDoidiemNav);
        updateDoidiemNav();
    }
});